import { useContext, useEffect, useRef } from "react";
import SuccessToast from "../toasts/SuccessToast";
import MqttManager from "../../mqtt/Base";
import { MqttContext } from "../../context/MQTTContext";
import { Context } from "../../context/Context";

const ForeignScenarioLearnCodeModal = ({
  setForeignScenarioLearnCodeModal,
  handleAssignForeignScenario,
  foreignScenario,
}) => {
  const { devices, scenarioCommands } = useContext(Context);
  const { clients } = useContext(MqttContext);
  const modalName = useRef(null);
  const closeButton = useRef(null);
  const foreignScenarioRef = useRef(null);
  const mqttManager = new MqttManager();
  const client = useRef();

  useEffect(() => {
    if (foreignScenario) {
      foreignScenarioRef.current = foreignScenario;
    }

    setForeignScenarioLearnCodeModal(modalName);

    if (modalName.current) {
      const $modal = window.$(modalName.current);

      $modal.on("show.bs.modal", function () {
        if (foreignScenarioRef.current) {
          let commands = scenarioCommands.filter(
            (c) => c.scenario_id == foreignScenarioRef.current.id
          );
          let device = devices.find((d) => d.id == commands[0].device_id);
          if(!device){
            return;
          }
          if (device.is_bus == 1) {
            if (!clients[device.bridge_device.id]) return;
            // تعریف تابع برای لیسنر پیام‌ها
            const messageListener = (topic, message, packet) => {
              const endOfTwoCharToken =
                String.fromCharCode(message[0]) +
                String.fromCharCode(message[1]);
              const deviceSerial =
                String.fromCharCode(message[3]) +
                String.fromCharCode(message[4]) +
                String.fromCharCode(message[5]) +
                String.fromCharCode(message[6]) +
                String.fromCharCode(message[7]) +
                String.fromCharCode(message[8]);
              if (
                device.bridge_device.internet_token.slice(-2) ===
                  endOfTwoCharToken &&
                device.serial === deviceSerial &&
                message[10] == 8 &&
                message[2] == 14
              ) {
                SuccessToast(
                  "به سناریو خارجی" + " " + message[11] + " " + "اختصاص یافت"
                );
                clients[device.bridge_device.id].off(
                  "message",
                  messageListener
                );
                closeButton.current.click();
              }
            };

            // ثبت لیسنر پیام‌ها
            clients[device.bridge_device.id].on("message", messageListener);
            handleAssignForeignScenario(foreignScenarioRef.current);

            // تنظیم تایمر برای بستن مدال بعد از 15 ثانیه
            const timer = setTimeout(() => {
              $modal.modal("hide");
            }, 15000);

            // پاکسازی تایمر هنگام بستن مدال
            $modal.on("hide.bs.modal", () => clearTimeout(timer));
          } else {
            if (!clients[device.id]) return;
            // تعریف تابع برای لیسنر پیام‌ها
            const messageListener = (topic, message, packet) => {
              const endOfTwoCharToken =
                String.fromCharCode(message[0]) +
                String.fromCharCode(message[1]);
              if (
                device.internet_token.slice(-2) === endOfTwoCharToken &&
                message[2] == 8
              ) {
                SuccessToast(
                  "به سناریو خارجی" + " " + message[3] + " " + "اختصاص یافت"
                );
                clients[device.id].removeAllListeners("message");
                closeButton.current.click();
              }
            };

            // ثبت لیسنر پیام‌ها
            clients[device.id].on("message", messageListener);
            handleAssignForeignScenario(foreignScenarioRef.current);

            // تنظیم تایمر برای بستن مدال بعد از 15 ثانیه
            const timer = setTimeout(() => {
              $modal.modal("hide");
            }, 15000);

            // پاکسازی تایمر هنگام بستن مدال
            $modal.on("hide.bs.modal", () => clearTimeout(timer));
          }
        }
      });

      return () => {
        $modal.off("show.bs.modal");
      };
    }
  }, [
    foreignScenario,
    setForeignScenarioLearnCodeModal,
    handleAssignForeignScenario,
  ]);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleClickCancel = () => {
    if (foreignScenarioRef.current) {
      let commands = scenarioCommands.filter(
        (c) => c.scenario_id == foreignScenarioRef.current.id
      );
      let device = devices.find((d) => d.id == commands[0].device_id);
      if(!device){
        return;
      }
      if (device.is_bus == 1) {
        if (!clients[device.bridge_device.id]) return;
        let buffer = new ArrayBuffer(10);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 6;
        asciiCode[9] = 7;
        let message = device.bridge_device.internet_token;
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage
        );
        closeButton.current.click();
      } else {
        if (!clients[device.id]) return;
        let buffer = new ArrayBuffer(2);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 6;
        asciiCode[1] = 7;
        let message = device.internet_token;
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.id].publish(device.serial + "/sys", combinedMessage);
        closeButton.current.click();
      }
    }
  };

  return (
    <div
      className="modal fade"
      id="learnCodeModal"
      tabIndex="-1"
      aria-labelledby="learnCodeLabel"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="learnCodeLabel">
              یادگیری
            </h5>
            <button
              type="button"
              className="btn-close d-none"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <p>لطفا دکمه ریموت را بفشارید</p>
          </div>
          <div className="modal-footer">
            {/* <button
              type="button"
              className="btn btn-outline-success-app"
              onClick={handleClickCancel}
            >
              انصراف
            </button> */}
            <button className="btn btn-success-app" type="button" disabled>
              <span
                className="spinner-border"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForeignScenarioLearnCodeModal;
